<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
        </div>
        <h5>Import Passwords from Excel</h5>
        <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="importPassword()">
            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Select File</label>
                <input type="file" class="form-control file-select" accept=".xlsx" (change)="onFileChange($event)">
            </div>

            <button class="btn btn-primary btn-lg col-md-10" type="submit"> Import
            </button>
        </form>
        <div class="d-flex align-content-between justify-content-between mt-2">
            <a href="/assets/templates/ImportPasswordsFromExcel.xlsx" download>
                Download Template</a>
        </div>
    </div>
</div>